module.exports = __webpack_public_path__ + "img/mascot-no-content.81615c38.svg";